import { HeroMesh } from './HeroMesh';

/** Plan·Inquiry 공통 상단 히어로 */
export function PageHero({ title, children }) {
  return (
    <section className="page-hero" aria-labelledby="page-title">
      <HeroMesh variant="plan" />
      <div className="inner relative z-10 py-8">
        <p className="mb-3">
          <img
            src="/assets/images/logo-nova-white.png"
            alt="Nova"
            width="2272"
            height="657"
            className="h-8 w-auto"
            fetchPriority="high"
          />
        </p>
        <h1 id="page-title" className="hero-title">
          {title}
        </h1>
        <p className="hero-copy mt-[120px]">{children}</p>
      </div>
    </section>
  );
}
